// extracted by mini-css-extract-plugin
export default {"root":"IconSearchMaterial_root__fphLD"};